"use strict";
import { jsx } from "react/jsx-runtime";
import { Fragment, useEffect, useState } from "react";
export const AsyncWrapper = (props) => {
  const { resolver, children } = props;
  const [Component, setComponent] = useState(() => Fragment);
  useEffect(() => {
    async function resolveComponent() {
      var _a;
      const component = (_a = await resolver()) != null ? _a : Fragment;
      setComponent(() => component);
    }
    resolveComponent();
  }, [resolver]);
  return /* @__PURE__ */ jsx(Component, { children });
};
